import { useMapIsUpdating } from '../hooks'

const LoadingIndicator = ({ mapId }) => {
  const active = useMapIsUpdating(mapId)
  
  if (!active) return null
  return (
    <div className="map--layer-loading">
      <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
      <div className="lds-label">...loading</div>
    </div>
  )
}

export default LoadingIndicator